import {events as priceEstimatorEvents} from '../../scripts/services/price-estimator.service/events';
import currencyItems from '../../scripts/enums/currency';

export default ['$scope', '$filter', '$sce', '$rootScope', function ($scope, $filter, $sce, $rootScope) {
  this.currency = '';
  this.price = 0;

  $scope.$on(priceEstimatorEvents.ESTIMATED_PRICE_UPDATED, (event, price) => {
    const currency = currencyItems.find(item => item.key === price.currency);
    this.currency = currency ? $sce.trustAsHtml(currency.name) : '';
    this.price = angular.isNumber(price.value) ? $filter('currency')(price.value, '', 0) : undefined;
    if (price.moreLink) this.moreLink = price.moreLink;
    this.dealType = price.dealType;
    this.isEnabled = this.price ? true : false;
  });

  $rootScope.$on(priceEstimatorEvents.STOP_WATCHING, () => {
    this.isEnabled = false;
  });

  this.onBannerClose = () => {
    // Закомментировано, так как расчитанная цена используется и в блоке нотификации о ошибочной цене.
    // $scope.$emit(priceEstimatorEvents.STOP_WATCHING);
  };
}];
